import Button from "@components/blocks/Button";
import Section from "@components/Section";
import { Title } from "@justhome/react-ui";
import { ComponentSectionsCta } from "@lib/generated/graphql";
import { FC } from "react";

export interface CtaProps {
  data: ComponentSectionsCta;
}

const Cta: FC<CtaProps> = ({ data }) => {
  return (
    <Section section={data} className="text-center my-3xl m:my-[120px]">
      {data.title && <Title className="text-h2">{data.title}</Title>}
      {data.button && <Button {...data.button} className="mx-auto mt-3s" />}
    </Section>
  );
};

export default Cta;
